import { makeAutoObservable } from 'mobx';

import { AppLayout } from '@/dmdrive/core/constants/layout';
import { AppError } from '@/dmdrive/core/entities/AppError';
import { AuthService } from '@/dmdrive/core/service/AuthService';
import { UserAPI } from '@/dmdrive/user/api/UserAPI';
import { User } from '@/dmdrive/user/entities/User';

export class AppStore {
  error: Nullable<AppError> = null;
  layout!: AppLayout;

  isReady: boolean = false;

  user: Nullable<User> = null;

  private userAPI: UserAPI;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    this.userAPI = new UserAPI();

    this.resize();
    window.addEventListener('resize', this.resize);
  }

  *initApp() {
    this.isReady = false;

    try {
      this.user = yield this.userAPI.getUserInfo();

      this.isReady = true;
    } catch (e) {
      this.error = new AppError(e);
    }
  }

  *logout() {
    try {
      this.isReady = false;

      AuthService.clearAuthData();

      yield this.userAPI.logout();

      AuthService.redirectToLogin();
    } catch (e) {
      this.isReady = true;

      this.error = new AppError(e);
    }
  }

  dispose() {
    this.error = null;
    this.user = null;
    this.isReady = false;

    window.removeEventListener('resize', this.resize);
  }

  resize() {
    if (window.innerWidth < 1024) {
      this.layout = AppLayout.Mobile;

      return;
    }

    this.layout = AppLayout.Desktop;
  }
}
